import React, { useContext } from 'react'
import { FileExcel, FilePdf } from 'react-bootstrap-icons'
import { Link } from 'react-router'
import Pagination from '../components/Pagination'
import Export from '../../pdf/Export'
import { RechercheContext } from '../Recherche'

function ResultatTanzanie({ data }) {

    const provider = useContext(RechercheContext);

    const toExcel = () => {
        if (data.nombre > 1000) alert("Limite 1000 déclarations dépassable");
        else provider.exportExcel();
    }

    const seeDetails = (evt) => {
        evt.preventDefault();
        const url = evt.target.getAttribute('url');
        window.open(url, '_blank', 'width=800,height=600');

    }

    return (
        <>
            <div className='d-flex justify-content-between'>
                <div>
                    Total Résultat : {data.nombre}
                </div>
                <div>
                    <button className='btn btn-success me-2' onClick={toExcel}><FileExcel className='fs-3' /></button>
                    <button className='btn btn-danger' onClick={() => { new Export().traListe(data.data) }}><FilePdf className='fs-3' /></button>
                </div>
            </div>
            <div className='table-responsive'>
                <table className='table table-hover' style={{ fontSize: '12px' }}>
                    <thead>
                        <tr>
                            <th>Véhicule/Conteneur</th>
                            <th>Importateur</th>
                            <th>Marchandise</th>
                            <th>Déclaration</th>
                            <th>Poids</th>
                            <th>Valeur Facture</th>
                            <th>CIF</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.data.map(d => {
                                return (
                                    <tr>
                                        <td>{d.vehicule}
                                            {d.conteneurs && (<><br />{d.conteneurs}</>)}
                                        </td>
                                        <td>{d.importateur}</td>
                                        <td>{d.nature}</td>
                                        <td>
                                            <a href={"/details/tra/" + d.declaration} target="_blank" rel="noopener noreferrer">{d.declaration}</a>
                                        </td>
                                        <td>{d.poids}</td>
                                        <td>{d.valeur_facture}</td>
                                        <td>{d.cif}</td>
                                        <td>{d.debut_periode}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
            {
                data.nombre > data.limite && <Pagination totalItems={data.nombre} currentPage={data.page} itemsPerPage={data.limite} />
            }

        </>
    )
}

export default ResultatTanzanie